const data2 = [
    {
        id: 1,
        name: "BlockChair",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/BlockChair/BlockChair.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/BlockChair/BlockChair.glb"
      }
  ,
    {
        id: 2,
        name: "BlockChair2",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/BlockChair2/BlockChair2.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/BlockChair2/BlockChair2.glb"
      }
  ,
    {
        id: 3,
        name: "BlockSeat",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/BlockSeat/BlockSeat.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/BlockSeat/BlockSeat.glb"
      }
  ,
    {
        id: 4,
        name: "Chair",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Chair/Chair.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Chair/Chair.glb"
      }
  ,
    {
        id: 5,
        name: "Chair2",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Chair2/Chair2.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Chair2/Chair2.glb"
      }
  ,
    {
        id: 6,
        name: "CrazySofa",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/CrazySofa/CrazySofa.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/CrazySofa/CrazySofa.glb"
      }
  ,
    {
        id: 7,
        name: "Cushion",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Cushion/Cushion.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Cushion/Cushion.glb"
      }
  ,
    {
        id: 8,
        name: "FunSeat",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/FunSeat/FunSeat.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/FunSeat/FunSeat.glb"
      }
  ,
    {
        id: 9,
        name: "FutureTable",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/FutureTable/FutureTable.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/FutureTable/FutureTable.glb"
      }
  ,
    {
        id: 10,
        name: "LongTab",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/LongTab/LongTab.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/LongTab/LongTab.glb"
      }
  ,
    {
        id: 11,
        name: "LoungeChair",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/LoungeChair/LoungeChair.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/LoungeChair/LoungeChair.glb"
      }
  ,
    {
        id: 12,
        name: "LoungeChairBig",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/LoungeChairBig/LoungeChairBig.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/LoungeChairBig/LoungeChairBig.glb"
      }
  ,
    {
        id: 13,
        name: "MiniTab",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/MiniTab/MiniTab.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/MiniTab/MiniTab.glb"
      }
  ,
    {
        id: 14,
        name: "MiniTable",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/MiniTable/MiniTable.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/MiniTable/MiniTable.glb"
      }
  ,
    {
        id: 15,
        name: "Ottoman",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Ottoman/Ottoman.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Ottoman/Ottoman.glb"
      }
  ,
    {
        id: 16,
        name: "Pad",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Pad/Pad.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Pad/Pad.glb"
      }
  ,
    {
        id: 17,
        name: "PlaneSeat",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/PlaneSeat/PlaneSeat.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/PlaneSeat/PlaneSeat.glb"
      }
  ,
    {
        id: 18,
        name: "RoundSofa",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/RoundSofa/RoundSofa.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/RoundSofa/RoundSofa.glb"
      }
  ,
    {
        id: 19,
        name: "Seat",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Seat/Seat.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Seat/Seat.glb"
      }
  ,
    {
        id: 20,
        name: "SwedishChair",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/SwedishChair/SwedishChair.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/SwedishChair/SwedishChair.glb"
      }
  ,
    {
        id: 21,
        name: "Tab",
        contentImage: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Tab/Tab.png",
        modelURL: "https://metaverse.seam.com.tr/uploads/mugen-furniture/Tab/Tab.glb"
      }
  ];
  export default data2;
  